
import React from 'react';
import { useTranslation } from "@common/hooks/translation";
import ToggleSwitch from "@common/components/toggleSwitch";

import "./style.scss";

const VerificationToggle = ({ value, onChange }) => {
	const t = useTranslation();

	return (
		<div className="bet-builder-verification-toggle">
			<span>{t("I'm not registered yet")}</span>
			<ToggleSwitch onChange={() => onChange(!value)} checked={value} />
		</div>
	);
};

export default VerificationToggle;
